import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AstralAccordionComponent } from './component/astral-components/astral-accordion/astral-accordion.component';
import { AstralButtonComponent } from './component/astral-components/astral-button/astral-button.component';
import { AstralCheckboxComponent } from './component/astral-components/astral-checkbox/astral-checkbox.component';
import { AstralChipComponent } from './component/astral-components/astral-chip/astral-chip.component';
import { AstralDatePickerComponent } from './component/astral-components/astral-date-picker/astral-date-picker.component';
import { AstralFieldActionComponent } from './component/astral-components/astral-field-action/astral-field-action.component';
import { AstralFieldShellComponent } from './component/astral-components/astral-field-shell/astral-field-shell.component';
import { AstralFieldAccessibilityDirective } from './component/astral-components/astral-field-accessibility.util';
import { AstralFormComponent } from './component/astral-components/astral-form/astral-form.component';
import { AstralInputComponent } from './component/astral-components/astral-input/astral-input.component';
import { AstralImagePreviewComponent } from './component/astral-components/astral-image-preview/astral-image-preview.component';
import { AstralLayoutGroupComponent } from './component/astral-components/astral-layout-group/astral-layout-group.component';
import { AstralMaskedInputComponent } from './component/astral-components/astral-masked-input/astral-masked-input.component';
import { AstralPopoverComponent } from './component/astral-components/astral-popover/astral-popover.component';
import { AstralRadioGroupComponent } from './component/astral-components/astral-radio-group/astral-radio-group.component';
import { AstralRemoteMultiSelectComponent } from './component/astral-components/astral-remote-multi-select/astral-remote-multi-select.component';
import { AstralSelectComponent } from './component/astral-components/astral-select/astral-select.component';
import { AstralTextareaComponent } from './component/astral-components/astral-textarea/astral-textarea.component';
import { AstralTabsComponent } from './component/astral-components/astral-tabs/astral-tabs.component';
import { AstralTimePickerComponent } from './component/astral-components/astral-time-picker/astral-time-picker.component';
import { AstralToggleComponent } from './component/astral-components/astral-toggle/astral-toggle.component';
import { AstralTypeaheadComponent } from './component/astral-components/astral-typeahead/astral-typeahead.component';
import { AccordionComponent } from './component/accordion/accordion.component';
import { ActionWindowComponent } from './component/action-window/action-window.component';
import { ApexChartComponent } from './component/apex-chart/apex-chart.component';
import { AutocompleteRemotePagedComponent } from './component/autocomplete-remote-paged/autocomplete-remote-paged.component';
import { AutocompleteRemoteMultiComponent } from './component/autocomplete-remote-multi/autocomplete-remote-multi.component';
import { AutocompleteRemoteComponent } from './component/autocomplete-remote/autocomplete-remote.component';
import { AutocompleteComponent } from './component/autocomplete/autocomplete.component';
import { ButtonCreateComponent } from './component/btn-create/btn-create.component';
import { CheckboxFreeformFunctionalComponent } from './component/check-box/check-box-freeform-functional.component';
import { CheckboxFreeformComponent } from './component/check-box/check-box-freeform.component';
import { CheckBoxComponent } from './component/check-box/check-box.component';
import { DateBoxComponent } from './component/date-box/date-box.component';
import { DatePickerComponent } from './component/date-picker/date-picker.component';
import { DateTimeBoxComponent } from './component/date-time-box/date-time-box.component';
import { WeekPickerComponent } from './component/date-week-picker/date-week-picker.component';
import { DialogBoxComponent } from './component/dialog-box/dialog-box.component';
import { EmailBoxComponent } from './component/email-box/email-box.component';
import { FileUploadComponent } from './component/file-upload/file-upload.component';
import { HelpTextComponent } from './component/help-text/help-text.component';
import { InformationBlockComponent } from './component/information-block/information-block.component';
import { IntBoxComponent } from './component/int-box/int-box.component';
import { LettingTranslationControl } from './component/letting-translation-control/letting-translation-control.component';
import { AccordionListViewComponent } from './component/list/accordion-list-view/accordion-list-view.component';
import { ContextMenuInlineComponent } from './component/list/context-menu-inline/context-menu-inline.component';
import { ContextMenuComponent } from './component/list/context-menu/context-menu.component';
import { DataCellToogleComponent } from './component/list/data-cell/data-cell-toogle.component';
import { DataCellComponent } from './component/list/data-cell/data-cell.component';
import { ExpandedListViewComponent } from './component/list/expanded-list-view/expanded-list-view.component';
import { FilterComponent } from './component/list/filter/filter.component';
import { ListManagementSidebarComponent } from './component/list/list-management-sidebar/list-management-sidebar.component';
import { ListViewHeaderComponent } from './component/list/list-view-header/list-view-header.component';
import { ListViewItem } from './component/list/list-view-item.directive';
import { ListViewToolbarComponent } from './component/list/list-view-toolbar/list-view-toolbar.component';
import { ListViewComponent } from './component/list/list-view/list-view.component';
import { MultiselectListViewComponent } from './component/list/multiselect-list-view/multiselect-list-view.component';
import { PagedListViewComponent } from './component/list/paged-list-view/paged-list-view.component';
import { PagingComponent } from './component/list/paging/paging.component';
import { PopupListViewComponent } from './component/list/popup-list-view/popup-list-view.component';
import { ToogleListViewComponent } from './component/list/toogle-list-view/toogle-list-view.component';
import { LocalDatePickerComponent } from './component/local-date-picker/local-date-picker.component';
import { MaskedTextBoxComponent } from './component/masked-text-box/masked-text-box.component';
import { MessageBoxComponent } from './component/message-box/message-box.component';
import { MoneyBoxComponent } from './component/money-box/money-box.component';
import { MonthYearSelectComponent } from './component/month-year-select/month-year-select.component';
import { MultiFileUploadComponent } from './component/multi-file-upload/multi-file-upload.component';
import { MultiFileUploadSortableComponent } from './component/multi-file-upload-sortable/multi-file-upload-sortable.component';
import { MultiFileUploadMiniComponent } from './component/multi-file-upload-mini/multi-file-upload-mini.component';
import { NotificationBarComponent } from './component/notification-bar/notification-bar.component';
import { NumberedCircleComponent } from './component/numbered-circle/numbered-circle.component';
import { NumericBoxComponent } from './component/numeric-box/numeric-box.component';
import { OrderedItemList } from './component/ordered-item-list/ordered-item-list.component';
import { PasswordComponent } from './component/password/password.component';
import { ProgressBarComponent } from './component/progress-bar/progress-bar.component';
import { RadioGroupComponent } from './component/radio-group/radio-group.component';
import { SearchFieldComponent } from './component/search-field/search-field.component';
import { SelectSliderComponent } from './component/select-slider/select-slider.component';
import { SelectFreeformComponent } from './component/select/select-freeform.component';
import { SelectComponent } from './component/select/select.component';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { SingleFileUploadComponent } from './component/single-file-upload/single-file-upload.component';
import { SliderComponent } from './component/slider/slider.component';
import { SnackbarComponent } from './component/snackbar/snackbar.component';
import { TabGroupComponent } from './component/tab-group/tab-group.component';
import { TabComponent } from './component/tab-group/tab/tab.component';
import { TextAreaLimitedComponent } from './component/text-area-limited/text-area-limited.component';
import { TextAreaFreeformComponent } from './component/text-area/text-area-freeform.component';
import { TextAreaComponent } from './component/text-area/text-area.component';
import { TextBoxReadonlyComponent } from './component/text-box-readonly/text-box-readonly.component';
import { TextBoxFreeformComponent } from './component/text-box/text-box-freeform.component';
import { TextBoxComponent } from './component/text-box/text-box.component';
import { TimeBoxComponent } from './component/time-box/time-box.component';
import { TimeDurationPickerComponent } from './component/time-duration-picker/time-duration-picker.component';
import { TimePickerComponent } from './component/time-picker/time-picker.component';
import { ToogleComponent } from './component/toogle/toogle.component';
import { TooltipComponent } from './component/tooltip/tooltip.component';
import { TranslateDialogFormComponent } from './component/translate-dialog-form/translate-dialog-form.component';
import { TranslateTextAreaComponent } from './component/translate-text-area/translate-text-area.component';
import { TranslateTextBoxComponent } from './component/translate-text-box/translate-text-box.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';
import { MarkScrolledDirective } from './directives/mark-scrolled.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { BooleanTextPipe } from './pipe/boolean-text.pipe';
import { CurrencyPipe } from './pipe/currency.pipe';
import { EtcPipe } from './pipe/etc.pipe';
import { ExecuteFuncPipe } from './pipe/execute-func.pipe';
import { KeywordFilterPipe } from './pipe/keyword-filter.pipe';
import { MenuFilterPipe } from './pipe/menu-filter.pipe';
import { AuthenticationClient } from './service/authentication-client.service';
import { CommandDispatcher } from './service/command/command-dispatcher.service';
import { CommandHandlerResolver } from './service/command/command-handler-resolver.service';
import { CreateCommandHandler } from './service/command/create-command-handler.service';
import { DeleteCommandHandler } from './service/command/delete-command-handler.service';
import { EditCommandHandler } from './service/command/edit-command-handler.service';
import { StandardCommandHandlerResolver } from './service/command/standard-command-handler-resolver.service';
import { ComponentMessageDispatcher } from './service/component-message-dispather.service';
import { ChartDefinitionFactory } from './service/factory/chart-definition-factory.service';
import { ColumnDefinitionFactory } from './service/factory/column-definition-factory.service';
import { CommandFactoryService } from './service/factory/command-factory.service';
import { FormControlExFactory } from './service/factory/form-control-ex-factory.service';
import { HelpTextFactory } from './service/factory/help-text-factory.service';
import { ListViewColumnFactory } from './service/factory/list-view-column-factory.service';
import { FakeGuidService } from './service/fake-guid.service';
import { FileService, PDFValidator } from './service/file.service';
import { Interceptor } from './service/interceptor.service';
import { LanguageService } from './service/language.service';
import { ListPreferencesClient } from './service/list-preferences-client.service';
import { NativeWindowService } from './service/native-window.service';
import { NavigationService } from './service/navigation.service';
import { PendingChangesGuard } from './service/pending-changes.service';
import { SessionService } from './service/session.service';
import { StorageService } from './service/storage.service';
import { UserPreferencesService } from './service/user-preferences.service';
import { VersionInfoService } from './service/version-info.service';
import { EyeLinkComponent } from './component/eye-link/eye-link.component';
import { PhotoPreviewComponent } from './component/photo-preview/photo-preview.component';
import { FileControlHelper } from './service/file-control-helper.service';
import { DragDropListViewComponent } from './component/list/drag-drop-list-view/drag-drop-list-view.component';
import { DateTimePickerComponent } from './component/date-time-picker/date-time-picker.component';
import { MultilineTextCellComponent } from './component/list/multiline-text-cell/multiline-text-cell.component';
import { NumberedMultilineTextCellComponent } from './component/list/multiline-text-cell/numbered-multiline-text-cell.component';
import { ExcelListComponent } from './component/list/excel-list/excel-list.component';
import { UserExcelPreferencesService } from './service/user-excel-preferences.service';
import { ExcelPreferencesClient } from './service/excel-preferences-client.service';
import { ExcelExportService } from './service/excel-export.service';
import { ExcelManagementSidebarComponent } from './component/list/excel-management-sidebar/excel-management-sidebar.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    DragDropModule,
    OverlayModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatTooltipModule,
    MatPseudoCheckboxModule,
    MatSelectModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    RouterModule,
    TranslateDirective,
    TranslatePipe,
    ScrollingModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTabsModule,
    AstralAccordionComponent,
    AstralButtonComponent,
    AstralCheckboxComponent,
    AstralChipComponent,
    AstralDatePickerComponent,
    AstralFieldActionComponent,
    AstralFieldAccessibilityDirective,
    AstralFieldShellComponent,
    AstralFormComponent,
    AstralInputComponent,
    AstralImagePreviewComponent,
    AstralLayoutGroupComponent,
    AstralMaskedInputComponent,
    AstralPopoverComponent,
    AstralRadioGroupComponent,
    AstralRemoteMultiSelectComponent,
    AstralSelectComponent,
    AstralTextareaComponent,
    AstralTabsComponent,
    AstralTimePickerComponent,
    AstralToggleComponent,
    AstralTypeaheadComponent,
  ],
  declarations: [
    AccordionComponent,
    ActionWindowComponent,
    ApexChartComponent,
    DialogBoxComponent,
    SelectComponent,
    AutocompleteComponent,
    AutocompleteRemoteComponent,
    AutocompleteRemotePagedComponent,
    AutocompleteRemoteMultiComponent,
    ListViewComponent,
    DragDropListViewComponent,
    ListViewItem,
    PopupListViewComponent,
    MessageBoxComponent,
    MultiFileUploadComponent,
    MultiFileUploadMiniComponent,
    MultiFileUploadSortableComponent,
    MultiselectListViewComponent,
    PagedListViewComponent,
    AccordionListViewComponent,
    ToogleListViewComponent,
    TextBoxComponent,
    CheckBoxComponent,
    DatePickerComponent,
    DateTimePickerComponent,
    DragDropDirective,
    InfiniteScrollDirective,
    MarkScrolledDirective,
    ContextMenuComponent,
    ContextMenuInlineComponent,
    ToogleComponent,
    SelectSliderComponent,
    SingleFileUploadComponent,
    PasswordComponent,
    EmailBoxComponent,
    FileUploadComponent,
    IntBoxComponent,
    LocalDatePickerComponent,
    MaskedTextBoxComponent,
    DateBoxComponent,
    TextAreaComponent,
    DataCellComponent,
    DataCellToogleComponent,
    MultilineTextCellComponent,
    NumberedMultilineTextCellComponent,
    TextBoxReadonlyComponent,
    TranslateTextAreaComponent,
    TranslateTextBoxComponent,
    TranslateDialogFormComponent,
    HelpTextComponent,
    DateTimeBoxComponent,
    MoneyBoxComponent,
    NumericBoxComponent,
    ProgressBarComponent,
    CurrencyPipe,
    EtcPipe,
    KeywordFilterPipe,
    MenuFilterPipe,
    MonthYearSelectComponent,
    ExpandedListViewComponent,
    SliderComponent,
    TimeBoxComponent,
    TimeDurationPickerComponent,
    TimePickerComponent,
    NotificationBarComponent,
    FilterComponent,
    ListViewToolbarComponent,
    ListViewHeaderComponent,
    PagingComponent,
    ButtonCreateComponent,
    SidebarComponent,
    RadioGroupComponent,
    InformationBlockComponent,
    SnackbarComponent,
    TextAreaLimitedComponent,
    AccordionListViewComponent,
    TextAreaFreeformComponent,
    TextBoxFreeformComponent,
    SelectFreeformComponent,
    WeekPickerComponent,
    CheckboxFreeformComponent,
    NumberedCircleComponent,
    OrderedItemList,
    CheckboxFreeformFunctionalComponent,
    TabGroupComponent,
    TabComponent,
    TooltipDirective,
    TooltipComponent,
    ListManagementSidebarComponent,
    ExcelManagementSidebarComponent,
    SearchFieldComponent,
    EyeLinkComponent,
    ExecuteFuncPipe,
    PhotoPreviewComponent,
    LettingTranslationControl,
    ExcelListComponent,
  ],
  providers: [
    // Wave 2 MDC migration: MDC dropped legacy's underline-only form-field look;
    // standardize on the chosen 'outline' appearance app-wide.
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    AuthenticationClient,
    CreateCommandHandler,
    FileService,
    FileControlHelper,
    PDFValidator,
    ChartDefinitionFactory,
    ColumnDefinitionFactory,
    CommandDispatcher,
    CommandFactoryService,
    CommandHandlerResolver,
    ComponentMessageDispatcher,
    DeleteCommandHandler,
    EditCommandHandler,
    FakeGuidService,
    FormControlExFactory,
    HelpTextFactory,
    LanguageService,
    ListPreferencesClient,
    NativeWindowService,
    NavigationService,
    PendingChangesGuard,
    SessionService,
    StandardCommandHandlerResolver,
    StorageService,
    UserPreferencesService,
    ListViewColumnFactory,
    BooleanTextPipe,
    CurrencyPipe,
    EtcPipe,
    KeywordFilterPipe,
    MenuFilterPipe,
    DatePipe,
    TranslatePipe,
    UserExcelPreferencesService,
    ExcelPreferencesClient,
    ExcelExportService,
    VersionInfoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
  ],
  exports: [
    CommonModule,
    OverlayModule,
    AstralAccordionComponent,
    AstralButtonComponent,
    AstralCheckboxComponent,
    AstralChipComponent,
    AstralDatePickerComponent,
    AstralFieldActionComponent,
    AstralFieldAccessibilityDirective,
    AstralFieldShellComponent,
    AstralFormComponent,
    AstralInputComponent,
    AstralImagePreviewComponent,
    AstralLayoutGroupComponent,
    AstralMaskedInputComponent,
    AstralPopoverComponent,
    AstralRadioGroupComponent,
    AstralRemoteMultiSelectComponent,
    AstralSelectComponent,
    AstralTextareaComponent,
    AstralTabsComponent,
    AstralTimePickerComponent,
    AstralToggleComponent,
    AstralTypeaheadComponent,
    AccordionComponent,
    AutocompleteComponent,
    AutocompleteRemoteComponent,
    AutocompleteRemotePagedComponent,
    AutocompleteRemoteMultiComponent,
    ActionWindowComponent,
    ApexChartComponent,
    CurrencyPipe,
    EtcPipe,
    KeywordFilterPipe,
    MenuFilterPipe,
    DateTimeBoxComponent,
    DialogBoxComponent,
    CheckBoxComponent,
    ContextMenuComponent,
    ContextMenuInlineComponent,
    DateBoxComponent,
    FileUploadComponent,
    DatePickerComponent,
    DateTimePickerComponent,
    DragDropDirective,
    InfiniteScrollDirective,
    MarkScrolledDirective,
    EmailBoxComponent,
    IntBoxComponent,
    ExpandedListViewComponent,
    HelpTextComponent,
    ListViewComponent,
    ListViewItem,
    DragDropListViewComponent,
    PopupListViewComponent,
    LocalDatePickerComponent,
    MaskedTextBoxComponent,
    MatButtonModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MessageBoxComponent,
    MoneyBoxComponent,
    MonthYearSelectComponent,
    MultiFileUploadComponent,
    MultiFileUploadMiniComponent,
    MultiFileUploadSortableComponent,
    MultiselectListViewComponent,
    PagedListViewComponent,
    AccordionListViewComponent,
    ToogleListViewComponent,
    NumericBoxComponent,
    PasswordComponent,
    TextAreaComponent,
    TextBoxComponent,
    SelectSliderComponent,
    SingleFileUploadComponent,
    TextBoxReadonlyComponent,
    ToogleComponent,
    TranslateTextAreaComponent,
    TranslateTextBoxComponent,
    SelectComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateDirective,
    ProgressBarComponent,
    SliderComponent,
    TimeBoxComponent,
    TimeDurationPickerComponent,
    TimePickerComponent,
    NotificationBarComponent,
    FilterComponent,
    ScrollingModule,
    PagingComponent,
    ButtonCreateComponent,
    TranslatePipe,
    SidebarComponent,
    RadioGroupComponent,
    InformationBlockComponent,
    SnackbarComponent,
    MatCheckboxModule,
    MatTabsModule,
    TextAreaLimitedComponent,
    AccordionListViewComponent,
    TextAreaFreeformComponent,
    TextBoxFreeformComponent,
    SelectFreeformComponent,
    WeekPickerComponent,
    CheckboxFreeformComponent,
    NumberedCircleComponent,
    OrderedItemList,
    CheckboxFreeformFunctionalComponent,
    TabGroupComponent,
    TabComponent,
    TooltipDirective,
    SearchFieldComponent,
    EyeLinkComponent,
    ExecuteFuncPipe,
    PhotoPreviewComponent,
    LettingTranslationControl,
    ExcelListComponent,
    ExcelManagementSidebarComponent,
    ListManagementSidebarComponent,
  ],
})
export class CoreModule {}
